import React from "react";
import { getStoreLogo, getStoreName } from "../../utils/helpers/storeSetting";
import "./index.css";
import AkasLogo from "../AkasLogo";

const StoreBrandLogo = ({ storeSetting, variant = "sidebar", className = "", style = {}, showHint = false }) => {
  const logo = getStoreLogo(storeSetting, "");
  const storeName = getStoreName(storeSetting);
  const isLogin = variant === "login";
  const isPos = variant === "pos";

  // if (logo) {
  //   return (
  //     <img
  //       src={logo}
  //       alt={storeName}
  //       className={`akas-store-brand-image ${isLogin ? "is-login" : ""} ${isPos ? "is-pos" : ""} ${className}`}
  //       style={{
  //         maxHeight: isLogin ? "20em" : "3em",
  //         backgroundColor: "transparent",
  //         filter: "none",
  //         mixBlendMode: "normal",
  //         borderRadius: isLogin ? "0.5em" : 0,
  //         padding: isLogin ? "1em" : 0,
  //         marginTop: isLogin ? "1em" : 0,
  //         marginBottom: isLogin ? "1em" : 0,
  //         cursor: "pointer",
  //         ...style,
  //       }}
  //     />
  //   );
  // }

  return (
    <div
      className={`akas-store-brand-fallback ${isLogin ? "is-login" : ""} ${isPos ? "is-pos" : ""} ${className}`}
      style={{ cursor: "pointer", ...style }}>
      <AkasLogo className="akas-store-brand-mark" decorative />
      <span className="akas-store-brand-copy">
        <strong>Akas</strong>
        <small>{storeName}</small>
      </span>
      {showHint ? <span className="akas-store-brand-hint">Tambahkan logo</span> : null}
    </div>
  );
};

export default StoreBrandLogo;
